module.exports = __webpack_public_path__ + "img/22_22.d2eb2ced.png";